function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
let _ = (t)=>t, t;
import { keyframes } from '@emotion/react';
import { createStyles } from '../../utils/styleUtils/createStyles';
export const useStyles = createStyles((theme, hasHeading)=>{
    const fadeIn = keyframes(t || (t = _`
    0% {
      opacity: 0;
      pointer-events: none;
    }
    100% {
      opacity: 1;
    }
  `));
    const noHeading = !hasHeading ? {
        top: '10px'
    } : {};
    return {
        infobox: {
            zIndex: theme.zIndex.takeover,
            animation: `${fadeIn} 0.2s`,
            width: '340px',
            maxWidth: '94vw'
        },
        heading: {
            paddingRight: `${theme.space.xxl}px`
        },
        text: {
            paddingRight: `${theme.space.xxl}px`
        },
        closeButton: _object_spread({
            position: 'absolute',
            top: '12px',
            right: theme.space.s,
            color: theme.color.textOnBackground,
            background: 'transparent'
        }, noHeading)
    };
});
